export default "__VITE_ASSET__eEhuevCP__"